<div class="d-flex margin-bottom-15">
  <!--<h2 class="mainhead "><span class="text">City List</span></h2>-->
  <div class="ml-auto d-flex">
    <a class="filter btn  btn-circle btn-green adduserbtn ml-auto" href="javascript:void(0);" placement="left" tooltip="Add Seller" (click)="openModal(sellerListing,'panlestyle')"><i class="fa fa-plus icon" aria-hidden="true"></i></a>
  </div>
  </div>
  <div class="table-responsive">
  <table class="table basictable row-border hover">
    <thead>
      <tr>
        <th data-orderable="false">
          Actions
        </th>
        <th>
          Name
        </th>
        <th>
          Phone
        </th>
        <th>
          Seller Dashboard
        </th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of SellerDetailsLst; let i=index">
        <td style="width:10%">
          <a href="javascript:void(0);" (click)="openDeleteModal(RemoveDealContact,'deletemodal', item);" class="blueone" tooltip="Remove" placement="top">
            <i class="icofont icofont-close" aria-hidden="true"></i>
          </a>
        </td>
        <td>{{item.FirstName}}  {{item.LastName}}</td>
        <td>{{item.PhoneNumber ? (item.PhoneNumber | phone) : '-'}}</td>
        <td>
          <label class="custom-checkbox withoutlabel">
            <input type="checkbox" [(ngModel)]="item.IsSellerDashboardEnabled" (change)="grantSellerDashboardAccess(item.UserGuid,$event)" class="ng-pristine ng-valid ng-touched"><i></i>
          </label>
        </td>


      </tr>
    </tbody>
    <tfoot>
      <tr *ngIf="SellerDetailsLst?.length == 0">
        <td colspan="6" class="no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
<ng-template #sellerListing>
  <div id="acceptDiv">
    <div class="modal-header">
      <h4 class="modal-title pull-left">
        Add Seller
      </h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="clear()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label class="form-label">Email Address<span class="star">*</span></label>
        <input class="form-control" (change)="onEmailAddressChange();"[(ngModel)]="AddPrincipalModal.EmailAddress" #EmailId="ngModel" type="text" maxlength="50">
        <p class="redtext" *ngIf="(Validation.IsinValid(AddPrincipalModal.EmailAddress) && isSubmit) ||(EmailId.invalid && EmailId.touched)">Email Address is required </p>
        <p class="redtext" *ngIf="(!Validation.IsinValid(AddPrincipalModal.EmailAddress) && !Validation.isEmail(AddPrincipalModal.EmailAddress))">Invalid Email Address </p>
      </div>
      <div class="form-group autocomplete-design">
        <label class="form-label">First Name<span class="star">*</span></label>
        <input class="form-control" [(ngModel)]="AddPrincipalModal.FirstName" #firstname="ngModel" type="text" maxlength="50">
        <p class="redtext" *ngIf="(Validation.IsinValid(AddPrincipalModal.FirstName) && isSubmit) ||(firstname.invalid && firstname.touched)">First Name is required </p>
      </div>
      <div class="form-group">
        <label class="form-label">Last Name<span class="star">*</span></label>
        <input class="form-control" [(ngModel)]="AddPrincipalModal.LastName" #lastname="ngModel" type="text" maxlength="50">
        <p class="redtext" *ngIf="(Validation.IsinValid(AddPrincipalModal.LastName) && isSubmit) ||(lastname.invalid && lastname.touched)">Last Name is required </p>
      </div>

      <div class="form-group">
        <label class="form-label">Phone<span class="red">*</span></label>
        <input class="form-control"  #phoneNumberinput="ngModel"  required [(ngModel)]="AddPrincipalModal.PhoneNumber" mask='(000) 000-0000' type="text" maxlength="20">
        <p class="redtext" *ngIf="(Validation.IsinValid(AddPrincipalModal.PhoneNumber) && isSubmit) ||(phoneNumberinput.invalid && phoneNumberinput.touched)">Phone number is required </p>
      </div>
      <div class="text-right">
        <button class="btn btn-default btn-lg" id="closeModal" (click)="clear()">Cancel</button>
        <button class="btn btn-success btn-lg" (click)="SavePrincipalFromPropDashboard()">Add Seller</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #RemoveDealContact>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Registered Users</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete this seller?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteSeller();" >Delete</button>
    </div>
  </div>

</ng-template>


